import { useDispatch } from 'react-redux';
import api from './axiosInstance.js';
import { setUserData, setUserDataError, setUserDataLoading } from '../redux/authSlice.js';

export const useUserData = () => {
  const dispatch = useDispatch();

  const userData = async () => {
    try {
      dispatch(setUserDataLoading(true));
      const response = await api.get(`/user-data`);
      dispatch(setUserData(response.data));
      return response;
    } catch (error) {
      dispatch(setUserDataError(true));
    }
  };

  return userData;
};

export const useUpdateUserData = () => {
  const dispatch = useDispatch();

  const updateUserData = async (params) => {    
    try {
      dispatch(setUserDataLoading(true));
      const response = await api.post(`/update-user-data`, params)
      dispatch(setUserData(response.data));
      return response;
    } catch (error) {
      dispatch(setUserDataError(true));
    }
  };

  return updateUserData;
};
